var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_18533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.0624 13.3495L21.2132 13.3495C20.8199 13.3563 20.4451 13.5173 20.1694 13.7979C19.8937 14.0784 19.7392 14.456 19.7392 14.8493C19.7392 15.2426 19.8937 15.6201 20.1694 15.9007C20.4451 16.1812 20.8199 16.3422 21.2132 16.349L32.4413 16.349L13.7885 35.0018C13.5072 35.2831 13.3492 35.6646 13.3492 36.0625C13.3492 36.4603 13.5072 36.8418 13.7885 37.1231C14.0698 37.4044 14.4514 37.5625 14.8492 37.5625C15.247 37.5625 15.6285 37.4044 15.9099 37.1231L34.5626 18.4704L34.5626 29.6985C34.5592 29.8977 34.5954 30.0955 34.6692 30.2805C34.743 30.4655 34.8529 30.6339 34.9926 30.776C35.1322 30.918 35.2987 31.0309 35.4824 31.1079C35.666 31.1849 35.8632 31.2246 36.0624 31.2246C36.2616 31.2246 36.4588 31.1849 36.6424 31.1079C36.8261 31.0309 36.9926 30.918 37.1322 30.776C37.2718 30.6339 37.3818 30.4655 37.4556 30.2805C37.5294 30.0955 37.5656 29.8977 37.5622 29.6985L37.5622 14.8493C37.5621 14.4515 37.4041 14.0701 37.1228 13.7888C36.8416 13.5076 36.4601 13.3495 36.0624 13.3495Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_18533"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0 25.4561) rotate(-45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowicon);
export default __webpack_public_path__ + "static/media/arrowicon.294f31475a3d7f3f7773299de899853c.svg";
export { ForwardRef as ReactComponent };